module.exports = __webpack_public_path__ + "img/image00009-min.054398b2.jpeg";